<template>
  <div
    id="headerBox"
    :style="{ height: headerCss.height + 'px', zoom: headerCss.zoom + '%' }"
  >
    <div id="pcHeader">
      <div class="NavLeft">
        <div class="logoContant">
          <el-tooltip placement="bottom-start" popper-class='version-tooltip' >
            <div slot="content">
              <div v-for="(item,index) in versionMessage" :key="index" class="tooltipItem">
                <div>{{item.serviceName=='Playout'?'TVU Channel':item.serviceName}} ( {{$t('lang.ENV')}}: {{item.tagName}} ):</div>
                <div class="version-content"> <span class="tooltipItem-Frontend" v-if="item.frontendVersion">{{$t('lang.Frontend')}}:</span><div>{{item.frontendVersion}}</div></div>
                <div class="version-content"> <span class="tooltipItem-Backend" v-if="item.backendVersion">{{$t('lang.Backend')}}:</span><div>{{item.backendVersion}}</div></div>
              </div>
              <div v-if="vmVersion"><span class="tooltipItem-vm">{{$t('lang.VMVersion')}}:</span>{{vmVersion}}</div>
            </div>
            <div class="tvuLogo"></div>
          </el-tooltip>
        </div>
      <el-divider direction="vertical" v-if="RouterPath != '/wb'"></el-divider>
      <div class="ChannelManagement" v-if="RouterPath == '/cm'">
        <i class="iconfont icon-fanhui" @click="Gotoback"></i><span @click="Gotoback">{{$t('lang.ChannelManagement')}}</span>
      </div>
      <div class="NavigationTop" v-else>
        <div
          class="Workbench"
          v-if="judgeWorkbench">{{ $t('lang.Workbench')}}</div>
        <div
          class="Program"
          v-else>
          <div class="backWorkbench" :class="{'OperatorOnly': hasPermission == 5}" v-if="RouterPath != '/AsRunLog'">
            <div class="BackPaogram">
              <i class="iconfont icon-fanhui" @click="backWorkbench"></i>
              <span @click="backWorkbench" class="ChannelName" :class="[ProgramRMessageAll.cloneRole==2?'cloneProgram':'']">
                {{ ProgramName ? ProgramName : $t('lang.ChannelName') }}
              </span>
              <div class="OperatorOnlyTitle" v-if="hasPermission == 5">
                <span>({{$t('lang.OperatorOnly')}})</span>
              </div>
              <!-- <div class="OfflineMode" ref="OfflineCutMode" v-if="OfflineOutputMode.OfflineMode">
                <div class="Offline" @click="OfflineOutputMode.OutputMode = !OfflineOutputMode.OutputMode">
                  <span>({{$t('lang.OfflineMode')}})</span><i class="el-icon-arrow-down"></i>
                </div>
                <div class="OpenOutputMode" v-if="OfflineOutputMode.OutputMode" @click="ToggleOutputMode">
                  {{$t('lang.StartOutputModule')}}
                </div>
              </div> -->
            </div>
          </div>
          <div id="navCommon" class="nav-common" v-if="RouterPath != '/AsRunLog'">
            <div v-if="!CloneDisabled.scheduler" :class="['tabTitle', {'router-link-active': RouterPath == '/po'}]" @click="GotoUrl('/po')">{{ $t("lang.Scheduler") }}</div>
            <div v-if="!CloneDisabled.playout" :class="['tabTitle', {'router-link-active': RouterPath == '/pop'}]" @click="GotoUrl('/pop')">{{ $t("lang.Playout") }}</div>
            <!-- <router-link to="pt">{{ $t("lang.Template") }}</router-link> -->
          </div>
          <div class="ChannelManagement" v-if="RouterPath == '/AsRunLog'">
            <span >{{programName}} {{$t('lang.AsRunLog')}}</span>
          </div>
          <div class="Power" v-if="RouterPath == '/po' || RouterPath == '/pop'">
            <div class="Disabled" v-if="OfflineOutputMode.disabledMode&&!StartingUpLoading.switch" ref="OfflineCutMode">
              <div class="DisabledButon">
                <span class="closePower">{{ $t('lang.Disabled') }}</span><i class="el-icon-arrow-down" @click="OfflineOutputMode.OutputMode = !OfflineOutputMode.OutputMode"></i>
              </div>
              <div class="EnableButton" v-if="OfflineOutputMode.OutputMode" @click="ToggleOutputMode">
                {{$t('lang.EnableChannel')}}
              </div>
            </div>
            <div class="Enable" v-if="StartingUpLoading.switch" >
              <i class="el-icon-loading"></i>{{$t('lang.Enabling')}}...
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="operateR">
        <header-time :judgeWorkbench="judgeWorkbench"></header-time>
        <!-- goLive -->
        <div v-if="!judgeWorkbench&&hasPermission!=2&&RouterPath != '/AsRunLog'" class="GoLive cursor" :class="{'disabled': CloneDisabled.Output}" @click="openOutput">
          <i class="iconfont icon-Shutdown"></i>
          <span>{{ $t('lang.goLive') }}</span>
        </div>
        <!-- 录制弹出框 -->
        <div
          class="StatusPop"
          @click="ShowPop"
          v-if="!judgeWorkbench"
          >
          <i class="iconfont icon-Message"></i>
        </div>
        <div class="HelpCenter">
          <tvu-help-center></tvu-help-center>
        </div>
        <!-- 用户信息盒子 -->
        <div class="userMessagWrap">
          <!-- 自己的信息 -->
          <div class="oneselfMessage">
            <div class="nickName">
              {{ TranslateName(StateObj.common.baseUserInfo.email) }}
            </div>
            <div class="userOperationWrap">
              <div class="userOperation">
                <div class="userTop">
                  <div class="headLeft">
                    <div class="nickName">
                      {{ TranslateName(StateObj.common.baseUserInfo.email) }}
                    </div>
                    <div class="message">
                      <div class="name">
                        {{ SelfMessage.userName ? SelfMessage.userName : StateObj.common.baseUserInfo.email }}
                      </div>
                      <div class="email">
                        {{ StateObj.common.baseUserInfo.email }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="jurisdiction"
                    v-if="SelfMessage.roles == 1">
                    {{ $t('lang.Owner') }}
                  </div>
                </div>
                <div class="userBottom">
                  <div class="Manager" v-if="ManagerJurisdiction"><span @click="GotoUrl('/cm')">{{ $t('lang.Manager') }}</span></div>
                  <div class="Manager" v-if="StateObj.common.baseUrl.useBillingService && billingLoaded"><span @click="TriggerBilling('manage')">{{ $t('lang.subManage') }}</span></div>
                  <div class="language">
                    <div>{{ $t('lang.Language') }}</div>
                    <div>
                      <span
                        :class="{ bilingual: langSelt == 'en' }"
                        @click="changeLangEvent('en')"
                      >{{ $t('lang.EN') }}</span
                      >
                      /
                      <span
                        :class="{ bilingual: langSelt == 'zh' }"
                        @click="changeLangEvent('zh')"
                      >{{ $t('lang.CN') }}</span
                      >
                    </div>
                  </div>
                  <div
                    class="loginOut"
                    @click="logout('logout')">{{ $t('lang.SignOut') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="MemberWrap"
            v-if="!judgeWorkbench && AllMemberList.length > 0"
          >
            <div class="longString"></div>
            <div class="MemberList">
              <div
                class="OtherUsers"
                v-for="(item, index) in AllMemberList"
                :key="index"
              >
                <div
                  class="LessThree"
                  v-if="AllMemberList.length <= 3 || (AllMemberList.length > 3 && index < 2)"
                >
                  <div
                    class="MemberName"
                    :style="{background: item.Color ? item.Color : 'rgb(15, 190, 113)'}"
                  >
                    {{ TranslateName(item.email) }}
                  </div>
                  <div class="OtherUserOperation">
                    <div class="OtherUserTop">
                      <div class="headLeft">
                        <div
                          class="nickName"
                          :style="{background: item.Color? item.Color : 'rgb(15, 190, 113)'}"
                        >
                          {{ TranslateName(item.email) }}
                        </div>
                        <div class="message">
                          <div class="name">
                            {{ item.userName ? item.userName : item.email }}
                          </div>
                          <div class="email">
                            {{ item.email }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="jurisdiction"
                        v-if="item.roles == 1">{{ $t('lang.Owner') }}</div>
                    </div>
                  </div>
                </div>
                <div
                  class="MoreThree"
                  v-if="AllMemberList.length > 3 && index == 2"
                >
                  <div
                    class="MemberName MoreUser"
                    @click="ShowUser = !ShowUser"
                  >
                    {{ $t(AllMemberList.length - 2) }}
                  </div>
                  <div
                    class="OtherUserOperation"
                    v-if="ShowUser">
                    <div class="OtherUserList">
                      <div
                        v-for="(item1, index1) in AllMemberList"
                        :key="index1"
                      >
                        <div
                          class="OtherUserTop"
                          v-if="index1 > 1">
                          <div
                            class="nickName"
                            :style="{background: item1.Color ? item1.Color : 'rgb(15, 190, 113)'}"
                          >
                            {{ TranslateName(item1.email) }}
                          </div>
                          <div class="message">
                            <div class="name">
                              {{ item1.userName ? item1.userName : item1.email }}
                            </div>
                            <div class="email">
                              {{ item1.email }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <tvu-service-jump-collect></tvu-service-jump-collect>
      </div>

      <header-output
      v-if="outputDialog.show"
      from="header"></header-output>
      <double-event-hint v-if="(RouterPath == '/po' || RouterPath == '/pop')&&StartingUpLoading.success"></double-event-hint>
    </div>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import headerOutput from '@/views/Workbench/headerOutput.vue'
import { componentsAnalyze } from '../../assets/js/googleAnalyze/playout.js'
import { loadVersionNews, loadBillingJs } from '@/assets/js/loadSudoku.js'
import { initBilling, queryBillingStatus, queryBilling } from '@/assets/js/BillingJs/index.js'
import HeaderTime from '@/components/common/HeaderTime.vue'
import DoubleEventHint from '@/components/common/Header/DoubleEventHint.vue'

export default {
  name: 'HeaderCc',
  computed: mapState({
    StateObj: (state) => state,
    pageRequest: (state) => state.websocket.pageRequest,
    pageRWebsocket: (state) => state.websocket.pageRWebsocket,
    CloneDisabled: (state) => state.playout.CloneDisabled,
    pageSerBusRequest: (state) => state.websocket.pageSerBusRequest
  }),
  components: {
    headerOutput,
    HeaderTime,
    DoubleEventHint
  },
  created () {
    if (this.timingGetVM) clearInterval(this.timingGetVM)
    this.getVersion()
    Bus.$on('closeHeaderOutput', () => {
      this.outputDialog.show = false
    })
    // 退出登录
    Bus.$on('jumpLoginPage', () => {
      const urlArr = JSON.parse(localStorage.getItem('newuserserviceLoginUrl'))
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      const userEmail = this.$store.state.common.baseUserInfo.email
      for (let i = 0; i < urlArr.length; i++) {
        const emailArr = urlArr[i].email.split(';')
        if (emailArr.includes(userEmail)) break
      }
      window.localStorage.setItem('channelSession', '')
      window.sessionStorage.setItem('userChangeInfo', '')
      sessionStorage.removeItem('ProgramRMessage')
      window.location.href = `${urlInfo.newUserServiceUrl}/?url=${urlInfo.playoutUrl}&serviceName=${urlInfo.playoutServerName}`
    })
    // 切换program
    Bus.$on('SwitchProgram', (data) => {
      this.getProgramName()
    })
    Bus.$on('TriggerBillingFun', () => {
      this.TriggerBilling()
    })
    // $(window).bind('hashchange', () => {
    //   this.toggleHeaderMobMenu = false
    //   $('#pro_nav_icon_bg').show()
    // })
    // $(window).resize(() => {
    //   if ($(window).width() > 1024) {
    //     $('#pro_nav_icon_bg').show()
    //   } else if (this.toggleHeaderMobMenu) {
    //     $('#pro_nav_icon_bg').hide()
    //   }
    // })

    this.IsEnterProgram(this.$route.path)
    this.DeleteHtmlClass(this.$route.path)
    // 如果验证Billing功能，刚进入页面时需要check Billing的状态，如果不验证Billing功能，则全项目放行
    if (this.$store.state.common.baseUrl.useBillingService) {
      loadBillingJs(async () => {
        if (!window.BillingObject) {
          initBilling(async () => {
            // 控制manage显示
            this.billingLoaded = true
          })
        } else {
          this.billingLoaded = true
          this.$store.state.common.billingStatus = await queryBillingStatus()
        }
      })
    } else {
      this.billingLoaded = true
      this.$store.state.common.billingStatus = true
    }
    // 集成VersionNew
    loadVersionNews(JSON.parse(window.localStorage.channelInitConfig).urlInfo || {}, Outil.getSession(), this.VersionNewsCall)
    if (!this.pageSerBusRequest) {
      this.$createWebsocket.pageSerBusRequest()
    }
    this.getVersionsTips()
    this.changeLangEvent(this.langSelt)
  },
  mounted () {
    // 创建websocket
    this.$createWebsocket.pageRequest()
    this.$createWebsocket.pageRWebsocket('', '', 'sendHeart')
    window.pageRequest = this.$store.state.websocket.pageRequest
    this.getProgramName()
    this.LineStatus()

    Outil.getManager((data) => {
      if (data.some(item => item.functionName == 'Manager' && item.functionPermission)) {
        this.ManagerJurisdiction = true
      } else {
        this.ManagerJurisdiction = false
      }
    })
    // this.SendAttributesHotjia()
    window.localStorage.setItem('lang', this.langSelt)
    document.addEventListener('click', this.clickEvent, true)
    // const ProgramMessage = Outil.getProgramReceiver()
    // if ((ProgramMessage.modeType === 0) && (this.$route.path == 'pop' || this.$route.path == 'po')) {
    //   this.getStartStatus()
    //   this.StartWebsocket()
    // }
  },
  data () {
    return {
      // 进入payout页面全部信息
      ProgramRMessageAll: Outil.getProgramReceiver(),
      routerPath: '/wb',
      // 定时任务获取vm
      timingGetVM: null,
      // 时间上限
      timeLimit: 0,
      RouterPath: '',
      // 本人信息
      SelfMessage: {},
      // 显示更多用户信息
      ShowUser: false,
      // 所有program成员信息
      AllMemberList: [],
      // Program信息
      ProgramId: '',
      ProgramName: '',
      // 用户颜色
      UserColor: {
        0: 'rgb(15, 190, 113)',
        1: 'rgb(70, 201, 225)',
        2: 'rgb(47, 141, 244)',
        3: 'rgb(255, 197, 115)',
        4: 'rgb(255, 106, 146)',
        5: 'rgb(255, 192, 0)',
        6: 'rgb(146, 72, 199)'
      },
      isPromptAlert: true,
      activeIndex: '1',
      menuList: [],
      headerCss: {
        height: 64,
        zoom: 0
      },
      langOps: {
        height: 28,
        width: 95,
        bg: '#424242',
        color: '#fff'
      },
      langSelt: langConfig.langValue || window.localStorage.getItem('lang') || navigator.language || navigator.userLanguage, // 获取当前浏览器语言
      setGridNumTimer: null, // 向Grid标签添加数量显示的定时器
      more10S: 1, // 超过10次清除定时器
      supportViewAccount: null, // 这个数组有数据代表,是support通过setting页面monitor操作用户跳转过来的 =>
      startLiveAlert: true,
      stopLiveAlert: true,
      alertTime: 1,
      setAlertNumTimer: null, // 向Grid标签添加数量显示的定时器
      // 判断是否是workbench
      judgeWorkbench: true,
      // 版本号
      version: '',
      outputDialog: {
        show: false
      },
      // 是否有权限
      ManagerJurisdiction: false,
      versionTipsContent: '',
      versionMessage: [],
      vmVersion: '',
      versionMap: { Playout: 'TVU Channel', NativeOverlay: 'Native Graphicis', 'Media Service': 'Media Service' },
      billingLoaded: false,
      // 离线推流模式
      OfflineOutputMode: {
        // OfflineMode: false,
        OutputMode: false,
        disabledMode: false
      },
      hasPermission: '',
      programName: '',
      OutputModeLoading: false,
      // 开机加载
      StartingUpLoading: {
        switch: false,
        success: false,
        lessen: false
      }
    }
  },
  props: ['height', 'background'],
  watch: {
    // 监听路由跳转
    $route (to, form) {
      if (form.name && form.name != 'ChannelManager') {
        this.routerPath = form.path
      }
      this.IsEnterProgram(to.path)
      if (form.path == '/wb') {
        console.log('进入channel')
        this.getVersion()
      } else if (to.path == '/wb' && form.path != '/') {
        console.log('没有进入channel')
        this.getVersion(1)
      }
      this.DeleteHtmlClass(to.path)
    },
    'StateObj.BehaviorChange' (data) {
      if (data.action == 'FeatureListChange') {
        this.$store.dispatch('playout/getFeatureList', { user: Outil.getProgramReceiver().ownerUserId })
      }
      if (data.action == 'removeShareProgram') {
        this.removeShareEvent(data)
      } else if (data.action == 'programTurnOn') {
        this.AutoToggleOutputMode(0)
      } else if (data.action == 'programTurnOff') {
        this.AutoToggleOutputMode(2)
      } else if (data.action == 'programTurnPause') {
        this.AutoToggleOutputMode(1)
      } else if (data.action == 'programTurnPermanentOff') {
        this.AutoToggleOutputMode(1)
        this.$confirm(`${this.$t('lang.permanentClickTip')}<br>${this.$t('lang.enabledAgain')}`, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('lang.GotIt'),
          showCancelButton: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          showClose: false
        }).then(() => {
          this.backWorkbench()
        }).catch(() => {
        })
      }
    },
    // 监听离线转开机
    'CloneDisabled.startingUpHint' (data) {
      if (!data) {
        this.getStartStatus()
      }
    }
  },
  methods: {
    ...mapActions('playout', ['getFeatureList']),
    ...mapMutations('playout', ['UserChannelPermission']),
    // Billing设置
    TriggerBilling (type) {
      queryBilling(type || 'createChannel')
    },
    // 获取开机状态
    getStartStatus () {
      const ProgramId = Outil.getProgramReceiver().ProgramId
      if (!ProgramId) return
      this.axios({
        method: 'post',
        url: Outil.getUrl('/program/checkReceiverReady'),
        data: {
          programId: ProgramId
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.StartingUpLoading.switch = false
          } else {
            this.StartingUpLoading.switch = true
            this.StartWebsocket()
          }
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    // websocket获取开机状态
    StartWebsocket () {
      const ProgramId = Outil.getProgramReceiver().ProgramId
      const urlInfo = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
      const { websocketServerName } = urlInfo
      this.StopWebsocket()
      this.pageSerBusRequest.send({
        message: {
          serverName: websocketServerName,
          data: JSON.stringify({
            data: JSON.stringify({
              programId: ProgramId
            }),
            module: 'receiverAlreadyReady'
          })
        },
        time: 5000,
        key: 'receiverAlreadyReady',
        success: (res) => {
          if (res.result && res.result.data == 'SUCCESS') {
            if (this.StartingUpLoading.switch) {
              this.$message({
                type: 'success',
                message: this.$t('lang.startingUpHint')
              })
            }
            this.StartingUpLoading.switch = false
            this.StartingUpLoading.success = true
            const ProgramRMessage = Outil.getProgramReceiver()
            ProgramRMessage.modeType = 0
            sessionStorage.setItem('ProgramRMessage', JSON.stringify(ProgramRMessage))
            this.StopWebsocket()
          } else if (res.result && res.result.data == 'CLOSE') {
            if (this.StartingUpLoading.switch) {
              this.$message({
                type: 'success',
                message: this.$t('lang.startAutomatically')
              })
            }
            this.StartingUpLoading.switch = false
            const ProgramRMessage = Outil.getProgramReceiver()
            ProgramRMessage.modeType = 1
            sessionStorage.setItem('ProgramRMessage', JSON.stringify(ProgramRMessage))
            this.StopWebsocket()
          } else {
            this.StartingUpLoading.switch = true
          }
        }
      })
    },
    // 停止预览
    StopWebsocket () {
      if (this.pageSerBusRequest) {
        this.$createWebsocket.pageSerBusRequest('stop', ['receiverAlreadyReady']) // 停止websocket
      }
    },
    // 获取用户在当前channel中的权限
    getProgramRoles (path) {
      const ProgramRMessage = Outil.getProgramReceiver()
      this.axios.post(Outil.getUrl('/programTeamMember/getByProgramIdAndUserId'), {
        programId: ProgramRMessage.ProgramId,
        userId: localStorage.getItem('userId')
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          this.hasPermission = result.roles
          this.UserChannelPermission(result.roles)
          this.$store.commit('playout/CloneDisabled')
          if ((result.roles == 5 || result.roles == 4) && path == '/po') {
            this.SpliceProgramId('/pop')
          }
          if (result.roles == 2) {
            this.$router.push({ path: '/po' })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 切换正常模式
    ToggleOutputMode () {
      this.OutputModeLoading = true
      const ProgramRMessage = Outil.getProgramReceiver()
      this.axios.post(Outil.getUrl('/program/open'), {
        programId: ProgramRMessage.ProgramId,
        modeType: 0
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.OfflineOutputMode.disabledMode = false
          this.OfflineOutputMode.OutputMode = false
          // this.$store.commit('playout/CloneDisabled')
          this.getStartStatus()
          this.getVersion()
          this.OutputModeLoading = false
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 自动切换到正常模式
    AutoToggleOutputMode (type) {
      const ProgramRMessage = Outil.getProgramReceiver()
      ProgramRMessage.modeType = type
      if (type == 2) {
        this.OfflineOutputMode.disabledMode = true
        this.OfflineOutputMode.OutputMode = false
      } else {
        this.OfflineOutputMode.disabledMode = false
        this.OfflineOutputMode.OutputMode = false
      }
      sessionStorage.setItem('ProgramRMessage', JSON.stringify(ProgramRMessage))
      this.$store.commit('playout/CloneDisabled')
      this.getVersion()
    },
    // 取消分享事件
    removeShareEvent (data) {
      const userId = localStorage.getItem('userId')
      const programId = this.$BehaviorSyns.getProgramId()
      const h = this.$createElement
      let targetObj = null
      if (userId == data.removeShareUserId) {
        if (userId == data.userId && programId == data.programId) {
          targetObj = h('div', null, [
            h('p', null, `${this.$t('lang.byMyselfRemove')} `)
          ])
        } else if (userId != data.userId && programId == data.programId) {
          targetObj = h('div', null, [
            h('span', null, `${this.$t('lang.Owner')} `),
            h('span', { style: 'color:#33AB4F' }, Outil.getProgramReceiver().ownerEmail),
            h('span', null, `${this.$t('lang.byTheOwnerRemove')}`)
          ])
        }
        this.$msgbox({
          title: '',
          message: targetObj,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false,
          confirmButtonText: this.$t('lang.GotIt')
        }).then(() => {
          this.$router.push({ path: '/wb' })
        }).catch(() => {})
      }
    },
    // 版本号提示
    getVersionsTips () {
      const versionNames = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo.needDisplayVersionOfServiceNames || []
      this.$backAndFrontVersion({
        ...this.$TVU,
        params: {
          serviceNameList: versionNames
        },
        success: (val) => {
          const newversionMessage = val.map((v) => {
            if (v.backendVersion) {
              if (v.backendVersion.includes('|')) {
                v.backendVersion = v.backendVersion.split('|')[0].toString()
                return { ...v }
              } else {
                return { ...v }
              }
            } else {
              return { ...v }
            }
          })
          const PlayoutList = newversionMessage.filter((v) => v.serviceName == 'Playout' || v.serviceName == 'TVU Channel')
          this.versionMessage.push(...PlayoutList)
          const noPlayoutList = newversionMessage.filter((v) => v.serviceName != 'Playout' && v.serviceName != 'TVU Channel')
          const notPlayoutList = noPlayoutList.sort(this.sortBankList('serviceName'))
          this.versionMessage.push(...notPlayoutList)
        },
        error: (val) => { // 接口失败的回调，会包含失败的状态码

        }
      })

      // console.log(this.versionMessage)
    },
    sortBankList (propertyName) {
      return function sortList (object1, object2) {
        const value1 = object1[propertyName]
        const value2 = object2[propertyName]
        if (value2 < value1) {
          return 1
        }
        if (value2 > value1) {
          return -1
        }
        return 0
      }
    },
    // 删除类名
    DeleteHtmlClass (path) {
      if (path == '/cm') {
        document.getElementById('ChannelHtml').classList.remove('GlobalStyle')
        document.getElementById('ChannelHtml').classList.add('ManagementStyle')
      } else {
        document.getElementById('ChannelHtml').classList.add('GlobalStyle')
      }
    },
    // 打开output
    openOutput () {
      if (this.CloneDisabled.Output) return
      this.outputDialog.show = true
      componentsAnalyze('headerGoLive', '/ponent')
    },
    // 中英文切换及设置
    changeLangEvent (langSelt) {
      if (langSelt === 'en') {
        componentsAnalyze('headerChangeLangEventEN', '/ponent')
      } else {
        componentsAnalyze('headerChangeLangEventZH', '/ponent')
      }
      window.localStorage.setItem('lang', langSelt)
      langConfig.changeLangCookie(langSelt)
      this.langSelt = langSelt
      this.$i18n.locale = langConfig.langValue
      if ($('.mediaDialog').length || $('#mediaOutputList').length) {
        mediaObj.changeType = 'changeLanguage'
        SM.__proto__.JumpMediaJs({ type: 'changeLanguage' })
      }
    },
    // 计算定位位置
    VersionNewsCall () {
      this.$nextTick(() => {
        const userMessagWrap = document.getElementsByClassName('userMessagWrap').length ? document.getElementsByClassName('userMessagWrap')[0] : null
        const VersionNews = document.getElementById('news_nav_icon_bg')
        if (userMessagWrap && VersionNews) {
          const clientWidth = userMessagWrap.clientWidth
          VersionNews.style.right = `${clientWidth + 93}px`
        }
      })
    },
    // 判断权限
    Jurisdiction (tabPrefix, path) {
      const ProgramRMessage = Outil.getProgramReceiver().ProgramId
      this.axios.post(Outil.getUrl('/programTeamMember/openPlayout'), {
        programId: ProgramRMessage,
        tabPrefix
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.SpliceProgramId(path)
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
            if (this.hasPermission == 5 || this.hasPermission == 4) {
              this.SpliceProgramId('/wb')
            } else {
              this.SpliceProgramId('/po')
            }
          }
        }
      }).catch(() => {})
    },
    // 判断是否进入program
    IsEnterProgram (path) {
      this.RouterPath = path
      this.ProgramId = this.$BehaviorSyns.getProgramId()
      if (path == '/wb' || !this.ProgramId) {
        if (path == '/AsRunLog') {
          this.judgeWorkbench = false
          this.programName = this.$route.query.programName
        } else {
          this.judgeWorkbench = true
        }
        this.AllMemberList = []
        this.SelfMessage = {}
        this.OfflineOutputMode.disabledMode = false
        this.hasPermission = ''
        this.UserChannelPermission('')
        this.VersionNewsCall()
        this.StopWebsocket()
      } else {
        this.judgeWorkbench = false
        const ProgramMessage = Outil.getProgramReceiver()
        // if (ProgramMessage.ProgramStatus == 2 || ProgramMessage.ProgramStatus == 3) {
        //   // this.$message({
        //   //   message: this.$t('lang.FirstOpenChannel'),
        //   //   type: 'warning'
        //   // })
        //   // ProgramMessage.ProgramStatus = 1
        //   // sessionStorage.setItem('ProgramRMessage', JSON.stringify(ProgramMessage))
        // }
        if (ProgramMessage.versionsHint) {
          ProgramMessage.versionsHint = false

          sessionStorage.setItem('ProgramRMessage', JSON.stringify(ProgramMessage))
          this.OwnerVersionsHint()
        }
        this.AllMember()
        this.getProgramRoles(path)
        this.$store.dispatch('playout/getFeatureList', { user: Outil.getProgramReceiver().ownerUserId })
        if (ProgramMessage.modeType == 2) {
          this.OfflineOutputMode.disabledMode = true
          this.StartingUpLoading.switch = false
        } else if (ProgramMessage.modeType === 0) {
          this.OfflineOutputMode.disabledMode = false
          this.getStartStatus()
          // this.StartWebsocket()
        } else {
          this.OfflineOutputMode.disabledMode = false
        }
      }
    },
    // 当前用户与拥有者所在环境差异
    OwnerVersionsHint () {
      const param = {
        userId: localStorage.getItem('userId'),
        programId: this.$BehaviorSyns.getProgramId()
      }
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/queryParentId', param)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
            const { dependencyServerNames } = urlInfo
            this.$syncVersionWarning({
              ...this.$TVU, // 参考使发手册设置的全局配置
              params: { // 请求接口所需要的参数
                userId: res.data.result.userId, // user ID
                serviceNameList: dependencyServerNames // 服务名称，以数组的方式
              }
            })
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 监听上下线
    LineStatus () {
      // 行为同步 上下线通知
      Bus.$on('programOnlineChange', (data) => {
        console.log('header')
        if (typeof data != 'object') {
          return
        }
        if (data.action == 'programOnlineModule') {
          this.AllMember()
        }
      })
    },
    // 获取program名字
    getProgramName () {
      this.$nextTick(() => {
        const ProgramRMessage = Outil.getProgramReceiver()
        if (ProgramRMessage) {
          this.ProgramName = ProgramRMessage.ProgramName
        }
      })
    },
    // 跳转页面
    GotoUrl (path) {
      if (this.RouterPath == path) {
        return
      }
      const channelInitConfig = localStorage.getItem('channelInitConfig') && JSON.parse(localStorage.getItem('channelInitConfig'))
      if (path == '/po') {
        this.SpliceProgramId(path)
        // 判断是否有进入pop权限
      } else if (path == '/cm') {
        const manageUrl = channelInitConfig.urlInfo.channelManageBaseUrl
        window.open(`${manageUrl}/channel-manage`, '_blank')
      } else {
        const programTabPrefix = channelInitConfig && channelInitConfig.urlInfo.programTabPrefix
        this.Jurisdiction(programTabPrefix.playoutTabPrefix, path)
      }
    },
    // 拼接
    SpliceProgramId (path) {
      // 链接上加ProgramId
      let ProgramId = ''
      if (path == '/po' || path == '/pop') {
        ProgramId = this.$BehaviorSyns.getProgramId()
      }
      this.$router.push({
        path,
        query: {
          ProgramId
        }
      })
    },
    // 返回上一个页面
    Gotoback () {
      this.$router.push({
        path: '/wb'
      })
    },
    // 跳转workbench页面
    backWorkbench () {
      componentsAnalyze('headerBackWorkbench', '/ponent')
      this.outputDialog.show = false
      this.$router.push({ path: '/wb' })
    },
    // program的所有成员
    AllMember () {
      const channelInitConfig = localStorage.getItem('channelInitConfig') && JSON.parse(localStorage.getItem('channelInitConfig'))
      const programTabPrefix = channelInitConfig && channelInitConfig.urlInfo.programTabPrefix
      this.ProgramId = this.$BehaviorSyns.getProgramId()
      if (!this.ProgramId) {
        return
      }
      let tabPrefix
      // 判断不同页面查询不同用户
      if (this.$route.path == '/pop' && programTabPrefix) {
        tabPrefix = programTabPrefix.playoutTabPrefix
      } else if (this.$route.path == '/po' && programTabPrefix) {
        tabPrefix = programTabPrefix.scheduleTabPrefix
      }
      this.axios.post(Outil.getUrl('/programTeamMember/listMember'), {
        programId: this.ProgramId,
        tabPrefix
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            if (this.StateObj.common.baseUserInfo) {
              if (!res.data.result) return
              this.AllMemberList = res.data.result.filter((item) => {
                if (this.StateObj.common.baseUserInfo.id != item.userId) {
                  item.Color = this.UserColor[Math.floor(Math.random() * 6)]
                } else {
                  this.SelfMessage = item
                }
                return this.StateObj.common.baseUserInfo.id != item.userId && item.online
              })
              this.VersionNewsCall()
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 显示弹出框
    ShowPop () {
      this.$emit('ShowPop', true)
      componentsAnalyze('headerShowPop', '/ponent')
    },
    // 转换名字
    TranslateName (name) {
      if (typeof name == 'string') {
        return name.substr(0, 2)
      } else {
        return name
      }
    },
    updateAccount (data) {
      const supportViewAccount = window.sessionStorage.getItem('userChangeInfo')
      if (supportViewAccount && JSON.parse(supportViewAccount)) {
        this.supportViewAccount = JSON.parse(supportViewAccount)
        this.$nextTick(() => {
          if (this.$refs.logoutBtn) {
            this.$refs.logoutBtn.show()
          }
        })
        this.$forceUpdate()
      } else {
        this.$nextTick(() => {
          if (this.$refs.logoutBtn) {
            this.$refs.logoutBtn.hide()
          }
        })
        this.supportViewAccount = null
      }
    },
    // 获取版本号
    getVersion (type) {
      const programId = type ? '' : this.$BehaviorSyns.getProgramId()
      if (this.timingGetVM) clearInterval(this.timingGetVM)
      this.getVersionRequest(programId)
      if (programId) {
        this.timeLimit = 0
        this.timingGetVM = setInterval(() => {
          this.timeLimit++
          if (this.timeLimit > 20) {
            clearInterval(this.timingGetVM)
          }
          this.getVersionRequest(programId)
        }, 20000)
      }
    },
    // 获取版本号请求
    getVersionRequest (programId) {
      this.axios({
        method: 'get',
        url: `/gatewayPlayoutUrl/tvu-playout/version/info/get?programId=${programId}`,
        withCredentials: true
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const { result } = res.data
          this.vmVersion = result.cloudReceiverVersion
          const ImageVersion = result.cloudReceiverVersion ? `/VM ImageVersion: ${result.cloudReceiverVersion}` : ''
          this.version = `UI：${window.localStorage.getItem('newChannelVersion')}/Backend: ${result.applicationName}-${result.buildVersion}${ImageVersion}`
          if (result.cloudReceiverVersion && this.timingGetVM) {
            clearInterval(this.timingGetVM)
          }
        } else {
          this.version = `UI：${window.localStorage.getItem('newChannelVersion')}`
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 退出登入
    logout (options) {
      if (options === 'logout') {
        componentsAnalyze('headerUserInfoSignOut', '/ponent')
        this.axios.get('/gatewayPlayoutUrl/tvu-playout/user/logout').then((res) => {
          const { errorCode } = res.data
          if (errorCode === '0x0') {
            window.localStorage.setItem('channelSession', '')
            window.sessionStorage.setItem('userChangeInfo', '')
            sessionStorage.removeItem('ProgramRMessage')
            sessionStorage.setItem('switchAccount', 'false')
            window.location.href = `${window.location.protocol}//${res.data.result.redirectUrl}`
            componentsAnalyze('headerLogout', '/ponent')
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
      } else if (options == 'changeToSupport') {
        componentsAnalyze('headerchangeToSupport', '/ponent')
        this.$confirm(this.$t('lang.gotoSupportTips'), '', {
          cancelButtonText: this.$t('lang.cancel'),
          confirmButtonText: this.$t('lang.i18n_confirm'),
          cancelButtonClass: 'btn-custom-cancel',
          type: 'warning',
          iconClass: 'myIcon'
        }).then(() => {
          const supportSession = this.supportViewAccount.supportUserInfo.session // 将要跳转的support的session
          const supportCookie = this.supportViewAccount.supportUserInfo.cookieSet // 将要跳转的support的cookie
          let pathKey = 'st'
          if (this.$route.path == '/st') {
            pathKey = 'stS'
          }
          // location = location + '/#/' + pathKey + '?session=' + supportSession;
          window.sessionStorage.setItem('userChangeInfo', '')
          window.localStorage.setItem('channelSession', supportSession)
          window.document.cookie = supportCookie // 设置cookie
          sessionStorage.setItem('switchAccount', 'true')
          // window.location.href = location; //更换session 刷新页面
          this.$router.push({
            path: `/${pathKey}`,
            query: {
              session: supportSession
            }
          })
        }).catch(() => {})
      }
    },
    // 点击组件之外地方
    clickEvent (e) {
      const event = e || window.event
      const tar = event.srcElement || event.target
      try {
        if (!this.$refs.OfflineCutMode.contains(tar)) {
          this.OfflineOutputMode.OutputMode = false
        }
      } catch (error) {
      }
    }
  },
  beforeDestroy () {
    if (this.timingGetVM) clearInterval(this.timingGetVM)
    Bus.$off('programOnlineChange')
    Bus.$off('SwitchProgram')
    document.removeEventListener('click', this.clickEvent, true)
    this.StopWebsocket()
  }
}
</script>
<style scoped lang="less">
.supportChangeColor {
  color: #60c871;
}

.supportDis {
  height: 45px;
  line-height: 45px;
  display: block;
  cursor: pointer;
}

.border {
  border-bottom: 1px solid #444;
}
#headerBox {
  background: #121212;
  position: relative;
  z-index: 2000;
  min-width: 1280px;

  #pcHeader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    min-width: 1280px;
    .NavLeft {
      display: flex;
      width: calc(100% - 700px);
      .el-divider--vertical{
        margin: 21px 7px;
        background-color: #444444;
        height: 21px;
      }
    }
    .logoContant,
    .operateR {
      height: 100%;
      .GoLive{
        margin-right: 27px;
        width: 90px;
        height: 30px;
        border-radius: 13px;
        border: #444444 solid 1px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 8px;
        i {
          color: #69AD48;
          margin-right: 5px;
        }
        span{
          color: #fff;
        }
      }
      .disabled{
        cursor: not-allowed;
      }
      ::v-deep.HelpCenter{
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        .icon-a-help1:before{
          content: "\E6F2";
          font-size: 24px;
          color: #fff;
        }
        .el-tabs .el-tabs__header .el-tabs__nav .el-tabs__item.is-top{
          width: fit-content;
        }
      }
    }

    .ChannelManagement{
      width: 320px;
      height: 64px;
      font-size: 16px;
      line-height: 64px;
      font-weight: bold;
      color: #ffffff;
      text-align: left;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .NavigationTop {
      width: calc(100% - 70px);
      .Workbench {
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        color: #DBDBDB;
        line-height: 64px;
      }
      .Program {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .backWorkbench {
          height: 19px;
          font-size: 16px;
          font-weight: bold;
          color: #DBDBDB;
          line-height: 19px;
          text-align: left;
          width: 134px;
          // min-width: 25%;
          // max-width: 37%;
          .BackPaogram {
            display: flex;
            align-items: center;
            cursor: pointer;
            .icon-fanhui {
              vertical-align: middle;
            }
            .ChannelName {
              display: inline-block;
              vertical-align: middle;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              // max-width: calc(100% - 60px);
            }
            .OfflineMode{
              width: 142px;
              position: relative;
              white-space: nowrap;
              .Offline{
                display: flex;
                align-items: center;
                .el-icon-arrow-down{
                  font-weight: 700;
                  margin-top: 5px;
                }
              }
              .OpenOutputMode{
                position: absolute;
                top: 32px;
                left: 45px;
                background: #444444;
                box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.5);
                border-radius: 4px;
                text-align: center;
                font-size: 14px;
                padding: 12px;
                white-space: nowrap;
                cursor: pointer;
              }
            }
          }
        }
        .OperatorOnly {
          min-width: 37%;
          max-width: 45%;
          .BackPaogram{
            // height: 64px;
            .OperatorOnlyTitle{
              color: #DBDBDB;
            }
          }
        }
        .Power{
          // position: absolute;
          // top: 50%;
          // left: 50%;
          // transform: translate(-50%,-50%);
          flex: 1;
          .Disabled{
            position: relative;
            .DisabledButon{
              font-size: 16px;
              font-weight: 700;
              .closePower{
                color: #E56464;
              }
              i{
                padding-left: 10px;
                color:  #CCCCCC;
                cursor: pointer;
              }
            }
            .EnableButton{
              position: absolute;
              top: 25px;
              left: 50%;
              background: #444444;
              box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.5);
              border-radius: 4px;
              text-align: center;
              font-size: 14px;
              padding: 12px;
              white-space: nowrap;
              cursor: pointer;
              color: #DBDBDB;
            }
          }
          .Enable{
            color: #DBDBDB;
            font-size: 16px;
            font-weight: 700;
            .Loading{
              width: 25px;
              height: 32px;
              ::v-deep .el-loading-mask{
                background-color: transparent;
                .el-loading-spinner{
                  top: 86%;
                .circular {
                    height: 16px;
                    width: 16px;
                  }
                }
              }
            }
            i{
              color: #33AB4F;
            }
          }

        }
      }
    }
    .operateR {
      display: flex;
      align-items: center;
      .StatusPop {
        width: 40px;
        height: 40px;
        line-height: 40px;
        i {
          font-size: 24px;
          color: #fff;
        }
      }
      .userMessagWrap {
        height: 40px;
        user-select: none;
        display: flex;
        .oneselfMessage {
          width: 100%;
          position: relative;
          .nickName {
            width: 32px;
            height: 32px;
            background: #5250ec;
            border-radius: 50%;
            text-align: center;
            line-height: 32px;
            font-size: 18px;
            font-weight: bold;
            color: #ffffff;
            margin: 4px;
          }
          .userOperationWrap {
            position: absolute;
            top: 32px;
            right: -65px;
            padding-top: 12px;
            display: none;
            z-index: 11;
            .userOperation {
              position: relative;
              width: 340px;
              height: 170px;
              background: #252525;
              box-shadow: 0px 0px 15px 0px rgba(16, 4, 0, 0.72);
              border-radius: 8px;
              .userTop {
                height: 90px;
                display: flex;
                justify-content: space-between;
                padding-left: 24px;
                padding-right: 24px;
                padding-top: 24px;
                .headLeft {
                  display: flex;
                }
                .nickName {
                  width: 42px;
                  height: 42px;
                  line-height: 42px;
                  font-size: 20px;
                }
                .message {
                  text-align: left;
                  margin-left: 12px;
                  .name {
                    font-size: 14px;
                    font-weight: bold;
                    color: #dbdbdb;
                    line-height: 17px;
                  }
                  .email {
                    font-size: 12px;
                    color: #666666;
                    line-height: 14px;
                    margin-top: 4px;
                  }
                }
                .jurisdiction {
                  font-size: 14px;
                  color: #dbdbdb;
                  line-height: 17px;
                }
              }
              .userBottom {
                background: #333333;
                padding-bottom: 12px;
                .Manager{
                  line-height: 40px;
                  height: 40px;
                  color: #dbdbdb;
                  cursor: pointer;
                  padding: 0 24px;
                  text-align: left;
                }
                .language {
                  height: 40px;
                  display: flex;
                  padding: 0 24px;
                  justify-content: space-between;
                  align-items: center;
                  div {
                    color: #dbdbdb;
                    cursor: pointer;
                    .bilingual {
                      color: #33ab4f;
                    }
                  }
                }
                .loginOut {
                  padding: 0 24px;
                  height: 40px;
                  color: #dbdbdb;
                  text-align: left;
                  line-height: 40px;
                  cursor: pointer;
                }
              }
            }
            .userOperation::after {
              content: "";
              border: solid 14px;
              border-color: transparent transparent #252525 transparent;
              position: absolute;
              top: -25px;
              right: 70px;
            }
          }
        }
        .oneselfMessage:hover .userOperationWrap {
          display: block;
        }
        .MemberWrap {
          display: flex;
          .longString {
            width: 1px;
            height: 32px;
            background: #257e3a;
            margin: 4px 10px;
          }
          .MemberList {
            display: flex;
            .OtherUsers {
              .MemberName {
                width: 32px;
                height: 32px;
                background: #5250ec;
                border-radius: 50%;
                text-align: center;
                line-height: 32px;
                font-size: 18px;
                font-weight: bold;
                color: #ffffff;
                margin: 4px;
              }
              .LessThree {
                position: relative;
                .OtherUserOperation {
                  position: absolute;
                  top: 32px;
                  right: -70px;
                  padding-top: 12px;
                  display: none;
                  .OtherUserTop {
                    width: 340px;
                    height: 64px;
                    background: #252525;
                    box-shadow: 0px 0px 15px 0px rgba(16, 4, 0, 0.72);
                    border-radius: 8px;
                    display: flex;
                    justify-content: space-between;
                    padding-left: 24px;
                     padding-right: 24px;
                    .headLeft {
                      display: flex;
                      align-items: center;
                      .nickName {
                        width: 42px;
                        height: 42px;
                        line-height: 42px;
                        font-size: 20px;
                        border-radius: 50%;
                      }
                      .message {
                        text-align: left;
                        margin-left: 12px;
                        .name {
                          font-size: 14px;
                          font-weight: bold;
                          color: #dbdbdb;
                          line-height: 17px;
                        }
                        .email {
                          font-size: 12px;
                          color: #666666;
                          line-height: 14px;
                          margin-top: 4px;
                        }
                      }
                    }
                    .jurisdiction {
                      font-size: 12px;
                      color: #dbdbdb;
                      line-height: 14px;
                      margin-top: 24px;
                    }
                  }
                  .OtherUserTop::after {
                    content: "";
                    border: solid 14px;
                    border-color: transparent transparent #252525 transparent;
                    position: absolute;
                    top: -15px;
                    right: 75px;
                  }
                }
              }
              .LessThree:hover .OtherUserOperation {
                display: block;
              }
              .MoreThree {
                position: relative;
                .MoreUser {
                  background: #cccccc;
                }
                .OtherUserOperation {
                  position: absolute;
                  top: 40px;
                  right: -70px;
                  padding-top: 12px;
                  .OtherUserList {
                    background: #252525;
                    box-shadow: 0px 0px 15px 0px rgba(16, 4, 0, 0.72);
                    border-radius: 8px;
                  }
                  .OtherUserTop {
                    width: 340px;
                    height: 64px;
                    display: flex;
                    align-items: center;
                    padding-left: 24px;
                    .nickName {
                      width: 42px;
                      height: 42px;
                      line-height: 42px;
                      font-size: 20px;
                      border-radius: 50%;
                    }
                    .message {
                      text-align: left;
                      margin-left: 12px;
                      .name {
                        font-size: 14px;
                        font-weight: bold;
                        color: #dbdbdb;
                        line-height: 17px;
                      }
                      .email {
                        font-size: 12px;
                        color: #666666;
                        line-height: 14px;
                        margin-top: 4px;
                      }
                    }
                  }
                  .OtherUserList::after {
                    content: "";
                    border: solid 14px;
                    border-color: transparent transparent #252525 transparent;
                    position: absolute;
                    top: -13px;
                    right: 75px;
                  }
                }
              }
            }
          }
        }
      }
      ::v-deep #tvu-service-jump-collect{
        margin-right: 7px;
        img{
          width: 50px;
          height: 50px;
        }
      }
    }

    .slotBox {
      position: relative;
      top: 50%;
      transform: translateY(-50%);

      div {
        font-size: 22px;
        font-weight: bold;
        color: #fff;
        text-align: left;
        // width:200px;
      }
    }
    .usrBox {
      padding-right: 75px;

      .userBtn {
        width: 65px;
        height: 45px;
        background: url("../../assets/img/user.png") no-repeat;
        display: inline-block;

        i {
          font-size: 18px;
          margin-left: 45px;
          font-weight: bold;
          margin-top: 12px;
          color: #fff;
        }
      }
    }
  }
}
#navCommon {
  width: 230px;
  height: 64px;
  line-height: 64px;
  display: flex;
  justify-content: flex-start;
  margin-left: 56px;
  .tabTitle {
    font-size: 16px;
    font-weight: bold;
    color: #DBDBDB;
    align-self: center;
    height: 60px;
    line-height: 60px;
    cursor: pointer;
    list-style: none;
    position: relative;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    white-space: nowrap;
    margin: 0 24px;
    display: inline-block;
    line-height: 60px;
  }
  .router-link-active {
    color: #33AB4F;
  }
}

/*覆盖elemen-ui drop样式*/
.el-dropdown {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

[v-cloak] {
  display: none !important;
}
</style>
<style lang="less">
.alert_message_box.el-notification {
  background-color: #444;
  box-shadow: 0px 0px 15px #100400;
  border: none;
  .el-notification__icon.el-icon-warning {
    color: #dc4e39;
    font-size: 20px;
  }
  .el-notification__title,
  .el-notification__content,
  .el-notification__closeBtn.el-icon-close {
    color: #fff;
  }
  .el-notification__title {
    width: 250px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .el-notification__content {
    width: 250px;
    > p > div > span {
      float: left;
    }
    > p > div > span:nth-child(2) {
      width: 225px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
.alert_icon {
  position: absolute;
  top: 0;
  right: -20px;
  background-color: #f57c00;
  text-align: center;
  color: #fff;
  width: 19px;
  height: 19px;
  line-height: 19px;
  border-radius: 9.5px;
  padding: 0;
  font-size: 12px;
}
.version-tooltip{
  width: 330px;
  .tooltipItem{
    border-bottom: 1px solid #555555;
    .version-content{
      display: flex;
       .tooltipItem-Frontend{
        padding-right: 8px;
      }
      .tooltipItem-Backend{
        padding-right: 12px;
      }
    }

  }
  .tooltipItem-vm{
    padding-right: 10px;
  }
}
</style>
